<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddDomainToBlacklist" @submit="formSubmit($event, 'addDomainToBlacklist')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addDomainToBlacklist',
                    fieldName:'domain'
                })"
                :value.sync="$v.forms.addDomainToBlacklist.domain.$model"
                :label="$t('domain')"
                :disables="true"
            />
            <!-- <CTextarea
                :isValid="checkIfFormValid({
                    formName:'addDomainToBlacklist',
                    fieldName:'reason'
                })"
                :value.sync="$v.forms.addDomainToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
            /> -->

            <CSelect
                :isValid="
                    checkIfFormValid({
                        formName: 'addDomainToBlacklist',
                        fieldName: 'reason',
                    })
                "
                :value.sync="$v.forms.addDomainToBlacklist.reason.$model"
                :label="$t('reason')"
                :disables="true"
                :placeholder="'Select type'"
                :options="[
                    { label: 'Spelling errors', value: 'Spelling errors' },
                    { label: 'Temporary Email', value: 'Temporary Email' },
                    { label: 'Spam', value: 'Spam' }
                ]"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addDomainToBlacklist._loading"
            >
                <span>{{ $t('Save') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("Cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.addDomainToBlacklist._loading">
                {{ $t("Save") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators"
import ButtonLoading from '~/components/ButtonLoading.vue';
export default {
    name: "AddDomainToBlacklistModal",
    mixins: [formMixin, validationMixin],
    components: {
        ButtonLoading
    },
    props:{
        title: String,
        show: Boolean,
        color: String,
        size: String
    },

    data(){
        return {
            titleComponent: null,
            showComponent:false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms:{
                addDomainToBlacklist:{
                    domain: null,
                    reason: null,
                    _loading: false,
                },
            }
        }
    },

    validations:{
        forms:{
            addDomainToBlacklist:{
                domain:{
                    required
                },
                reason:{
                    required
                }
            }
        }
    },

    watch:{
        title(){
            this.titleComponent = this.title;
        },
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('addDomainToBlacklist');
                this.$v.$reset();
            }
        },
        color(){
            this.colorComponent = this.color;
        },
        size(){
            this.sizeComponent = this.size;
        },

        showComponent(){
            this.$emit('update:show',this.showComponent);
        },
    },

    methods:{
        closeModal(){
            this.showComponent = false;
        },


        async formSubmit(e, formName){
            e.preventDefault();
            let response = await this.sendForm({ 
                formName , 
                url: '/headers.api/blacklist/domains'
            });
            this.showComponent = false;

            this.$emit('submit',response);
        },

        executeSubmitForm(){
            this.$refs.formAddDomainToBlacklist.requestSubmit();
        }
    },

    mounted(){
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
    },
};
</script>

<style>
</style>